import { HttpRequest } from '@angular/common/http';
import type {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
} from '@angular/common/http';
import type { Observable } from 'rxjs';
import { resolveApiUrlOverride } from '../api-url-override/api-url-override.store';

export class HttpBaseUrlAppenderInterceptor implements HttpInterceptor {
  // Keep the ORIGINAL `environment.urls.*` value so the dev/PR-only override
  // store can reverse-map it to its API key on each request.
  constructor(private baseUrl: string) {}

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    // Resolve any active override PER REQUEST so changing it (via the menu popup
    // or an agent channel) takes effect for all subsequent requests without a
    // page reload. No-op on stg/prod or when no override is set.
    const resolvedBaseUrl = resolveApiUrlOverride(this.baseUrl).replace(
      /\/$/,
      ''
    ); // trim end slash of base url
    const urlPath = req.url.replace(/^\/+/, ''); // trim starting slashes of the partial url
    req = req.clone({
      // `http://i.imgur.com/ETO2miA.jpg`
      // `${resolvedBaseUrl}/${urlPath}`
      url: `${resolvedBaseUrl}/${urlPath}`,
    });
    return next.handle(req);
  }
}
